import { render } from "./About.vue?vue&type=template&id=16a8b618&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=16a8b618&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a8b618"]])

export default __exports__